export const de = {
  common: {
    cancel: 'Abbrechen',
    checkingConnection: 'Verbindung wird geprüft',
    close: 'Schließen',
    delete: 'Löschen',
    deleteFileHint: '{{filename}} wird endgültig gelöscht.',
    download: 'Herunterladen',
    fileTooLarge: 'Die Datei ist größer als 25 MB.',
    notProvided: 'Nicht angegeben',
    oneMoment: 'Einen Moment',
    save: 'Speichern',
  },
  files: {
    open: '{{filename}} öffnen',
    remove: '{{filename}} entfernen',
  },
  roles: {
    owner: 'Inhaber',
    member: 'Mitglied',
    friend: 'Freund',
  },
  auth: {
    tabLogin: 'Anmelden',
    tabRegister: 'Konto erstellen',
    nameLabel: 'Name',
    namePlaceholder: 'Optional',
    emailLabel: 'E-Mail',
    emailPlaceholder: 'du@beispiel.de',
    passwordLabel: 'Passwort',
    passwordHint: 'Mindestens 8 Zeichen.',
    submitLogin: 'Anmelden',
    submitRegister: 'Konto erstellen',
    pendingLogin: 'Wird angemeldet',
    pendingRegister: 'Konto wird erstellt',
  },
  join: {
    checking: 'Einladung wird geprüft',
    toLogin: 'Zur Anmeldung',
    invitedTo: 'Du wurdest eingeladen zu',
    asRole: 'als {{role}}',
    signedInAs: 'Angemeldet als {{email}}',
    join: 'Beitreten',
    joining: 'Beitritt läuft',
    submitLogin: 'Anmelden und beitreten',
    submitRegister: 'Konto erstellen und beitreten',
  },
  invite: {
    cardTitle: 'Einladungslinks',
    cardHint:
      'Wer den Code scannt, tritt bei, auch ohne Konto. Behandle den Link wie ein Passwort. Du kannst ihn jederzeit zurückziehen.',
    none: 'Noch kein Link erstellt.',
    validUntil: 'Gültig bis {{date}}',
    qrTitle: 'Einladungslink als QR-Code',
    copyLink: 'Link kopieren',
    revoke: 'Einladungslink zurückziehen',
    roleSelect: 'Rolle für neuen Einladungslink',
    create: 'Einladungslink erstellen',
    creating: 'Wird erstellt',
  },
  overview: {
    title: 'Übersicht',
    hint: 'Was gerade offen ist.',
    empty: 'Hier ist noch nichts.',
  },
  members: {
    ownerHint: 'Du verwaltest diese Organisation.',
    memberHint: 'Du bist Mitglied dieser Organisation.',
    friendHint: 'Du bist als Freund dabei und siehst die Mitglieder.',
    cardTitle: 'Mitglieder',
    count_one: '{{count}} Person',
    count_other: '{{count}} Personen',
    you: '(du)',
    leave: 'Organisation verlassen',
    remove: '{{email}} entfernen',
  },
  organization: {
    loading: 'Organisationen werden geladen',
    welcomeTitle: 'Willkommen',
    welcomeHint: 'Lege eine Organisation an, um Personen einzuladen.',
    createTitle: 'Neue Organisation',
    createHint: 'Du wirst automatisch Inhaber.',
    cardTitle: 'Organisation',
    cardHint: 'Den Namen kannst du später nicht ändern.',
    nameLabel: 'Name',
    namePlaceholder: 'Meine Werkstatt',
    nameHint: '2 bis 60 Zeichen.',
    create: 'Anlegen',
    creating: 'Wird angelegt',
  },
  account: {
    title: 'Konto',
    hint: 'Deine Zugangsdaten.',
    cardTitle: 'Profil',
    avatarAdd: 'Profilbild wählen',
    avatarChange: 'Bild ändern',
    avatarRemove: 'Entfernen',
    avatarHint: 'JPG, PNG, WebP, AVIF oder GIF, maximal 10 MB.',
    avatarTooLarge: 'Das Bild ist größer als 10 MB.',
    name: 'Name',
    email: 'E-Mail',
    registered: 'Registriert',
    id: 'ID',
  },
  reminders: {
    title: 'Erinnerungen',
    hint: 'Gelten für die ganze Organisation. Jedes Mitglied darf sie anlegen und abhaken.',
    openTitle: 'Offen',
    doneTitle: 'Erledigt',
    none: 'Nichts offen.',
    add: 'Neue Erinnerung',
    addShort: 'Erinnerung anlegen',
    editTitle: 'Erinnerung bearbeiten',
    create: 'Anlegen',
    adding: 'Wird angelegt',
    save: 'Speichern',
    saving: 'Wird gespeichert',
    cancel: 'Abbrechen',
    titleLabel: 'Was',
    titlePlaceholder: 'Bremsen prüfen',
    noteLabel: 'Notiz',
    notePlaceholder: 'Optional',
    dueLabel: 'Fällig',
    dueHint: 'Ohne Datum wird nicht benachrichtigt.',
    repeatLabel: 'Wiederholung',
    repeatHint: 'Abgehakt springt die Erinnerung auf den nächsten Termin.',
    repeatNeedsDue: 'Eine Wiederholung braucht ein Datum.',
    repeatOnce: 'Einmalig',
    repeatDaily: 'Täglich',
    repeatWeekly: 'Wöchentlich',
    repeatMonthly: 'Monatlich',
    repeatYearly: 'Jährlich',
    assigneeLabel: 'Zuständig',
    everyone: 'Ganze Organisation',
    assigneeHint: 'Wer zuständig ist, wird allein benachrichtigt.',
    filesLabel: 'Dateien',
    filesHint:
      'Bis zu 10 Dateien, je maximal 25 MB. Bilder und PDFs werden beim Antippen angezeigt, alles andere heruntergeladen.',
    filesAfterCreate: 'Dateien kannst du anhängen, sobald die Erinnerung angelegt ist.',
    fileAdd: 'Datei hinzufügen',
    fileUploading: 'Wird hochgeladen',
    fileRemove: '{{filename}} entfernen',
    fileRemoveTitle: 'Datei löschen?',
    noDue: 'Ohne Datum',
    overdue: 'Überfällig seit {{when}}',
    dueOn: 'Fällig {{when}}',
    doneOn: 'Erledigt {{when}}',
    complete: '{{title}} abhaken',
    reopen: '{{title}} wieder öffnen',
    edit: '{{title}} bearbeiten',
    remove: '{{title}} löschen',
    removeTitle: 'Erinnerung löschen?',
    removeHint: '{{title}} wird mit allen Dateien endgültig gelöscht.',
    nudge: 'Jemanden auf {{title}} hinweisen',
    nudgeTitle: 'Jemanden hinweisen',
    nudgeHint: '{{title}} als Benachrichtigung auf das Gerät der Person schicken.',
    nudgeRecipient: 'Wer',
    nudgeSend: 'Hinweisen',
    nudgeSending: 'Wird gesendet',
    nudgeSent: 'An {{name}} gesendet.',
    nudgeNobody: 'Außer dir ist niemand in dieser Organisation.',
  },
  debts: {
    title: 'Schulden',
    hint: 'Was offen ist, was bezahlt ist und wann die nächste Zahlung fällig wird.',
    summaryTotal: 'Gesamt',
    summaryPaid: 'Bezahlt',
    summaryRemaining: 'Offen',
    summaryMonthly: 'Monatlich',
    summaryProgress: '{{percent}} % bezahlt',
    summaryDueThisMonth: 'Diesen Monat noch offen: {{amount}}',
    openTotalLabel: 'Offen insgesamt',
    progressAria: '{{percent}} % von {{total}} bezahlt',
    groupOverdue: 'Überfällig',
    groupThisWeek: 'Diese Woche',
    groupLater: 'Später',
    groupUndated: 'Ohne Termin',
    settledTitle: 'Bezahlt',
    noneHint: 'Leg die erste Schuld an. Nargus rechnet Raten und Termine mit.',
    allSettled: 'Alles bezahlt.',
    add: 'Neue Schuld',
    addShort: 'Schuld anlegen',
    editTitle: 'Schuld bearbeiten',
    dialogHint: 'Halte fest, was mit dem Gläubiger vereinbart wurde.',
    create: 'Anlegen',
    save: 'Speichern',
    creditorLabel: 'Gläubiger',
    creditorPlaceholder: 'Wem du das Geld schuldest',
    referenceLabel: 'Aktenzeichen',
    referencePlaceholder: 'Optional, z. B. Kundennummer',
    ibanLabel: 'IBAN',
    ibanPlaceholder: 'AT00 0000 0000 0000 0000',
    ibanHint: 'Optional. Für die Überweisung an den Gläubiger.',
    ibanCopy: 'IBAN kopieren',
    totalLabel: 'Gesamtbetrag in Euro',
    noteLabel: 'Notiz',
    notePlaceholder: 'Optional',
    planLabel: 'Vereinbarung',
    planHint: 'Entweder eine monatliche Rate oder eine einmalige Zahlung zu einem Termin.',
    planSingle: 'Einmalzahlung',
    planInstallment: 'Ratenzahlung',
    planSingleSummary: 'Einmalzahlung',
    planInstallmentSummary: 'Rate {{amount}} monatlich am {{day}}.',
    planNoAgreement: 'Noch nichts vereinbart',
    dueLabel: 'Zahlbar bis',
    dueHint: 'Ohne Datum wird nicht benachrichtigt.',
    installmentLabel: 'Rate in Euro',
    dueDayLabel: 'Fällig am Tag',
    dueDayHint: 'Tag im Monat. Kürzere Monate enden am letzten Tag.',
    noDue: 'Kein Termin',
    dueOn: 'Fällig {{when}}',
    overdue: 'Überfällig seit {{when}}',
    settledOn: 'Bezahlt am {{when}}',
    paidOf: '{{paid}} von {{total}}',
    payNow: 'Zahlung für {{creditor}} eintragen',
    payRest: 'Rest bezahlen ({{amount}})',
    nudge: '{{name}} erinnern',
    nudgeSent: '{{name}} wurde erinnert',
    nextDueLabel: 'Nächste Zahlung',
    personLabel: 'Person',
    personHint: 'Wem diese Schuld gehört. Nur Inhaber sehen und ändern das.',
    personAll: 'Alle Personen',
    personFilterLabel: 'Person',
    settledBadge: 'Bezahlt',
    backToList: 'Alle Schulden',
    removeDebt: 'Schuld löschen',
    removeDebtTitle: 'Schuld löschen?',
    removeDebtHint:
      '{{creditor}} wird mit allen Zahlungen und Dateien endgültig gelöscht.',
    paymentsLabel: 'Zahlungen',
    paymentsNone: 'Noch nichts bezahlt.',
    paymentsAfterCreate: 'Zahlungen und Dateien kannst du eintragen, sobald die Schuld angelegt ist.',
    paymentAddTitle: 'Zahlung eintragen',
    paymentEditTitle: 'Zahlung bearbeiten',
    paymentDialogHint: 'Wann und wie viel du an {{creditor}} gezahlt hast.',
    paymentAmountLabel: 'Betrag in Euro',
    paymentDateLabel: 'Datum der Zahlung',
    paymentFillRate: 'Rate ({{amount}})',
    paymentFillRest: 'Restbetrag ({{amount}})',
    paymentSave: 'Eintragen',
    paymentReceiptLabel: 'Zahlungsbeleg',
    paymentReceiptHint:
      'Optional, z. B. der Screenshot der Überweisung. Bild oder PDF, maximal 25 MB.',
    paymentReceiptPick: 'Beleg auswählen',
    paymentReceiptReplace: 'Beleg ersetzen',
    paymentReceiptClear: 'Auswahl verwerfen',
    paymentReceiptCurrent: 'Hinterlegt: {{filename}}',
    paymentRemove: 'Zahlung vom {{when}} löschen',
    paymentRemoveTitle: 'Zahlung löschen?',
    paymentRemoveHint: '{{amount}} vom {{when}} wird endgültig gelöscht.',
    receiptOpen: 'Beleg ansehen',
    filesLabel: 'Dateien',
    filesNone: 'Noch keine Dateien.',
    filesHint:
      'Bis zu 10 Dateien, je maximal 25 MB, z. B. Mahnungen oder Verträge. Bilder und PDFs werden beim Antippen angezeigt.',
    fileAdd: 'Datei hinzufügen',
    fileRemove: '{{filename}} entfernen',
    fileRemoveTitle: 'Datei löschen?',
  },
  photos: {
    title: 'Fotos',
    hint: 'Bilder und Videos, die alle in dieser Organisation sehen.',
    none: 'Noch keine Fotos. Zieh Dateien hierher oder füge sie aus der Zwischenablage ein.',
    noMatches: 'Keine Treffer.',
    add: 'Hinzufügen',
    uploading: 'Lädt hoch ({{done}} von {{total}})',
    dropHere: 'Dateien hier ablegen',
    skipped_one: 'Eine Datei war zu groß oder kein Bild und wurde übersprungen.',
    skipped_other:
      '{{count}} Dateien waren zu groß oder kein Bild und wurden übersprungen.',
    searchPlaceholder: 'Nach Titel oder Dateiname suchen',
    sort: 'Sortierung',
    sortNewest: 'Neueste zuerst',
    sortOldest: 'Älteste zuerst',
    favorites: 'Favoriten',
    favoriteAdd: 'Favorit',
    favoriteRemove: 'Favorit weg',
    favorite: 'Als Favorit merken',
    unfavorite: 'Favorit entfernen',
    select: '{{filename}} auswählen',
    deselect: '{{filename}} abwählen',
    selectedCount_one: 'Ein Foto ausgewählt',
    selectedCount_other: '{{count}} Fotos ausgewählt',
    clearSelection: 'Auswahl aufheben',
    toAlbum: 'Zu Album',
    toAlbumHint: 'Wähle ein Album oder lege ein neues an.',
    fromAlbum: 'Aus Album',
    share: 'Teilen',
    removeTitle_one: 'Foto löschen?',
    removeTitle_other: '{{count}} Fotos löschen?',
    removeHint_one: 'Das Foto wird endgültig gelöscht.',
    removeHint_other: 'Die {{count}} Fotos werden endgültig gelöscht.',
    previous: 'Vorheriges',
    next: 'Nächstes',
    zoomIn: 'Vergrößern',
    zoomOut: 'Verkleinern',
    slideshowStart: 'Diashow starten',
    slideshowStop: 'Diashow anhalten',
    info: 'Informationen',
    infoFile: 'Datei',
    infoTaken: 'Aufgenommen',
    infoDimensions: 'Auflösung',
    infoSize: 'Größe',
    infoDuration: 'Länge',
    infoUploader: 'Hochgeladen von',
    captionAdd: 'Titel hinzufügen',
    captionPlaceholder: 'Titel oder Beschreibung',
  },
  albums: {
    title: 'Alben',
    hint: 'Fotos zu Sammlungen gruppieren. Ein Foto kann in mehreren Alben sein.',
    none: 'Noch keine Alben.',
    create: 'Album anlegen',
    rename: 'Album umbenennen',
    remove: 'Album löschen',
    removeTitle: 'Album löschen?',
    removeHint: '{{name}} wird gelöscht. Die Fotos selbst bleiben erhalten.',
    nameLabel: 'Name',
    namePlaceholder: 'Zum Beispiel Urlaub 2026',
    count_one: 'Ein Foto',
    count_other: '{{count}} Fotos',
  },
  shares: {
    title: 'Freigaben',
    manage: 'Freigaben',
    shareAlbum: 'Album teilen',
    hintAlbum: 'Jeder mit dem Link sieht dieses Album, ohne Anmeldung.',
    hintSelection_one: 'Jeder mit dem Link sieht dieses Foto, ohne Anmeldung.',
    hintSelection_other:
      'Jeder mit dem Link sieht diese {{count}} Fotos, ohne Anmeldung.',
    create: 'Link erstellen',
    linkLabel: 'Link',
    copy: 'Link kopieren',
    expiryLabel: 'Gültig',
    never: 'Unbegrenzt',
    days_one: 'Ein Tag',
    days_other: '{{count}} Tage',
    until: 'Bis {{date}}',
    existing: 'Bestehende Freigaben',
    none: 'Keine Freigaben.',
    revoke: 'Freigabe zurückziehen',
    photoCount_one: 'Ein Foto',
    photoCount_other: '{{count}} Fotos',
    publicTitle: 'Geteilte Fotos',
    publicEmpty: 'Diese Freigabe enthält keine Fotos.',
  },
  push: {
    title: 'Benachrichtigungen',
    hint: 'Meldungen auch dann, wenn die App geschlossen ist.',
    askTitle: 'Benachrichtigungen einschalten?',
    askBody: 'Wir melden uns, wenn jemand deiner Organisation beitritt.',
    enable: 'Einschalten',
    enabling: 'Wird eingeschaltet',
    later: 'Später',
    disable: 'Ausschalten',
    on_one: 'Aktiv auf diesem Gerät.',
    on_other: 'Aktiv auf {{count}} Geräten.',
    off: 'Nicht eingeschaltet.',
    test: 'Testbenachrichtigung senden',
    testSent: 'Gesendet. Sie sollte gleich erscheinen.',
    denied:
      'Du hast Benachrichtigungen für diese Seite blockiert. Das lässt sich nur in den Browsereinstellungen zurücknehmen.',
    unsupported: 'Dieser Browser kann keine Push-Benachrichtigungen.',
    insecure:
      'Push braucht HTTPS. Über eine unverschlüsselte Verbindung sperrt der Browser die nötigen Funktionen.',
    unavailable: 'Der Server hat keine Push-Schlüssel hinterlegt.',
    notGranted:
      'Der Browser hat die Berechtigung nicht erteilt. Klicke erneut und bestätige die Abfrage mit "Zulassen".',
    browserFailed:
      'Der Browser konnte kein Push-Abo anlegen ({{reason}}). In Brave musst du dafür unter brave://settings/privacy "Use Google services for push messaging" einschalten und den Browser neu starten.',
  },
  routes: {
    notFoundTitle: 'Seite nicht gefunden',
    notFoundHint: 'Diese Adresse gibt es nicht oder nicht mehr.',
    toStart: 'Zur Startseite',
    retry: 'Erneut versuchen',
  },
  nav: {
    organizations: 'Organisationen',
    newOrganization: 'Neue Organisation',
    account: 'Konto',
    overview: 'Übersicht',
    members: 'Mitglieder',
    logout: 'Abmelden',
    userMenu: 'Nutzermenü öffnen',
    noOrganization: 'Keine Organisation ausgewählt.',
  },
  errors: {
    signInRequired: 'Bitte melde dich an.',
    sessionExpired: 'Deine Sitzung ist abgelaufen. Melde dich neu an.',
    badCredentials: 'E-Mail oder Passwort ist falsch.',
    emailTaken: 'Diese E-Mail ist bereits vergeben.',
    validation: 'Bitte prüfe deine Eingaben.',
    userGone: 'Dieses Konto gibt es nicht mehr.',
    organizationNotFound: 'Diese Organisation gibt es nicht, oder du hast keinen Zugriff.',
    inviteNotFound: 'Diese Einladung ist ungültig, abgelaufen oder zurückgezogen.',
    memberNotFound: 'Dieses Mitglied gibt es nicht.',
    ownersOnly: 'Das dürfen nur Inhaber.',
    ownersOnlyRemove: 'Nur Inhaber können Mitglieder entfernen.',
    friendsNoAccess: 'Freunde sehen Erinnerungen und Schulden nicht.',
    lastOwner: 'Eine Organisation braucht mindestens einen Inhaber.',
    reminderNotFound: 'Diese Erinnerung gibt es nicht mehr.',
    debtNotFound: 'Diese Schuld gibt es nicht mehr.',
    paymentNotFound: 'Diese Zahlung gibt es nicht mehr.',
    installmentIncomplete: 'Für eine Ratenzahlung brauchst du Rate und Fälligkeitstag.',
    debtorOwnersOnly: 'Nur Inhaber können eine Schuld einer anderen Person zuordnen.',
    debtorNotMember: 'Diese Person gehört nicht zur Organisation.',
    assigneeNotMember: 'Diese Person gehört nicht zur Organisation.',
    recipientNotMember: 'Diese Person gehört nicht zur Organisation.',
    nudgeSelf: 'Dich selbst brauchst du nicht zu erinnern.',
    debtSettled: 'Diese Schuld ist bereits bezahlt.',
    debtNoDebtor: 'Für diese Schuld ist niemand hinterlegt.',
    recipientNoPush: 'Diese Person hat Benachrichtigungen nicht eingeschaltet.',
    pushDeliveryFailed:
      'Die Benachrichtigung konnte nicht zugestellt werden. Vielleicht ist das Gerät der Person abgemeldet.',
    nothingToUpdate: 'Es gibt nichts zu ändern.',
    attachmentNotFound: 'Diese Datei gibt es nicht mehr.',
    attachmentLimit: 'Mehr als 10 Dateien gehen nicht.',
    attachmentTooLarge: 'Die Datei ist größer als 25 MB.',
    attachmentRejected: 'Die Datei konnte nicht übernommen werden.',
    storageUnavailable: 'Dateien sind auf diesem Server nicht eingerichtet.',
    photoNotFound: 'Dieses Foto gibt es nicht mehr.',
    photoLimit: 'Diese Organisation hat das Limit von 2000 Dateien erreicht.',
    photoOwnersOnly: 'Nur Inhaber können Fotos von anderen löschen.',
    mediaType: 'Nur Bilder (JPG, PNG, WebP, AVIF, GIF) und Videos (MP4, WebM, MOV).',
    albumNotFound: 'Dieses Album gibt es nicht mehr.',
    shareNotFound: 'Diese Freigabe gibt es nicht oder sie ist abgelaufen.',
    shareEmpty: 'Wähle ein Album oder mindestens ein Foto.',
    avatarType: 'Bitte wähle ein Bild (JPG, PNG, WebP, AVIF oder GIF).',
    serverError: 'Der Server hat einen Fehler gemeldet. Versuche es später.',
    offline: 'Keine Verbindung zum Server.',
    unknown: 'Unbekannter Fehler.',
    withStatus: 'Etwas ist schiefgelaufen. (Status {{status}})',
  },
} as const;
